import createManagementPageLifecycle from "@shared/createManagementPageLifecycle.cjs";

export default createManagementPageLifecycle({
  navbar: "8",
  navbarHook: "mounted",
  loadMethods: ["loadNotices"],
});
